export default __webpack_public_path__ + "static/media/new-cards.de4f154d.png";